export const activateCustomerSubscription = `
    mutation activateCustomerSubscription($id: ID!) {
        activateCustomerSubscription(id: $id) {
            id
            customerId
            status
        }
}`;

export const cancelCustomerSubscription = `
    mutation cancelCustomerSubscription($id: ID!) {
        cancelCustomerSubscription(id: $id) {
            id
            customerId
            status
        }
}`;

export const createSubscription = `
    mutation createCustomerSubscription($input: CreateCustomerSubscriptionInput!) {
        createCustomerSubscription(input:$input) {
            id
            customerId
        }
}`;

export const updateSubscription = `
    mutation updateCustomerSubscription($input: UpdateCustomerSubscriptionInput!) {
        updateCustomerSubscription(input:$input){
            id
            customerId
        }
}`;

export const deleteSubscription = `
    mutation deleteCustomerSubscription($input: DeleteCustomerSubscriptionInput!) {
        deleteCustomerSubscription(input:$input) 
}`;


